export default __webpack_public_path__ + "static/media/footer.90aee9d5.jpg";